import { CanDeactivateFn } from '@angular/router';

import { StandDivision } from './stand-division';

export const discardStandDivisionStateOnHomeNavigation: CanDeactivateFn<StandDivision> = (
  component,
  _currentRoute,
  _currentState,
  nextState,
) => {
  if (nextState.url === '/') {
    component.discardStateForHomeNavigation();
  }

  return true;
};
